/** @jsx isolateComponent */
import { clamp } from 'lodash';
import { isolateComponent, useHeadingLevel } from '@zapier/common-utils';

type HeadingProps = {
  /**
   * The content to render for the heading.
   */
  children: React.ReactNode;
  /**
   * The string provided by the `css` prop via emotion.
   * This should only ever be provided by the `css` prop!
   */
  className?: string;
  /**
   * The `css` prop for emotion. Enumerated
   * here to keep flow from complaining.
   */
  css?: any;
};

/**
 * Renders an `h*` tag of the appropriate level, based on how
 * deeply nested within the `HeadingLevel` hierarchy the component is.
 *
 * Tags: core-ui
 */
const Heading: React.FC<HeadingProps> = props => {
  const { level } = useHeadingLevel();
  const headingLevel = clamp(level, 1, 6);
  const Tag = `h${headingLevel}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  return <Tag className={props.className}>{props.children}</Tag>;
};

export default Heading;
